 let lastRecoKey = '';

async function loadSidecartRecommendations(cart) {
  const wrap = document.querySelector('.js-sidecart-recommended-wrap');
  if (!wrap || !cart.items || !cart.items.length) return;

 
  const key = cart.items.map((i) => i.product_id).join(',');
  if (key === lastRecoKey) return;

  try {
    const sectionId = wrap.dataset.sectionId;
    const limit = wrap.dataset.limit || 8;
    const intent = wrap.dataset.intent || 'related';
    const productId = cart.items[0].product_id; 

    const res = await fetch(
      `/recommendations/products?section_id=${encodeURIComponent(sectionId)}` +
        `&product_id=${productId}&limit=${limit}&intent=${intent}`
    );
    if (!res.ok) throw new Error('Recommendations failed: ' + res.status);

    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const newWrapper = doc.querySelector('.js-sidecart-recommended-product .swiper-wrapper');
    const slider = wrap.querySelector('.js-sidecart-recommended-product');
    const currentWrapper = slider && slider.querySelector('.swiper-wrapper');

    
    if (!newWrapper || !newWrapper.children.length || !currentWrapper) return;

    
    if (slider.swiper) slider.swiper.destroy(true, true);

    currentWrapper.innerHTML = newWrapper.innerHTML;

   
    const seen = new Set();
    currentWrapper.querySelectorAll('.js-sidecart-recommended-product__slide').forEach((el) => {
      const id = el.dataset.prodsuggest;
      if (seen.has(id)) el.remove();
      else seen.add(id);
    });

    lastRecoKey = key;
  } catch (e) {
    console.error('[sidecart-recommended]', e);
  }
}

function updateShippingProgress(cart) {
  $(".cart-sidebar__progress").each(function () {
    var $el = $(this);
    var threshold = parseInt($el.data("threshold"), 10) || 8500; // cents
    var total = cart.total_price;
    var remaining = Math.max(threshold - total, 0);
    var percent = Math.min((total / threshold) * 100, 100);
    var marker = Math.min(Math.max(percent, 5), 100);
    var unlocked = cart.item_count > 0 && remaining === 0;

    if (cart.item_count === 0) {
      percent = 0;
      marker = 5;
      remaining = threshold;
    }

    var remainingText = (remaining / 100) % 1 === 0
      ? (remaining / 100).toFixed(0)
      : (remaining / 100).toFixed(2);

    $el.toggleClass("is-unlocked", unlocked);

    if (unlocked) {
      $el.find(".progress-title").html("<strong>Congrats!</strong> You have unlocked <strong>Free Shipping!</strong>");
      $el.find(".shipping-progress__label").html("Free shipping");
    } else {
      $el.find(".progress-title").html(
        'Add <strong>$' + remainingText + '</strong> to unlock <strong>Free Shipping!</strong>'
      );
      $el.find(".shipping-progress__label").html("Free shipping <br> over $" + (threshold / 100));
    }

    $el.find(".progress-fill").css("width", percent + "%");
    $el.find(".shipping-progress__goal").css("left", marker + "%");
  });
}

function updateCart() {
  $(".js-loader-wrap").addClass("active");
  $.ajax({
    url: "/cart?view=ajax-cart-drawer",
    dataType: "HTML",
    method: "GET",
    success: function(htmlData) {
      let newHtml = $(htmlData);
      let newItemsHtml = newHtml.find(".cart-sidebar__item-row.order-items").html();
      let subTotal = newHtml.find(".js-cart-sidebar__summary-value").html();
      let $currentItems = $(".cart-sidebar__item-row.order-items");
      let sideCartsidebarSummryNote = document.querySelectorAll(".js-cart-sidebar__summry-note");
      if ($currentItems.html().trim() !== newItemsHtml.trim()) {
        $currentItems.html(newItemsHtml); // Refresh items without closing drawer
      }
     
      $(".js-cart-sidebar__summary-value").html(subTotal);
      $(".cart-sidebar__empty-cart").hide();
      $.getJSON("/cart.json", async function(cart) {
        await  loadSidecartRecommendations(cart); 
        updateShippingProgress(cart);
        // Loop through all items in the cart
        $.each(cart.items, function (index, item) {
          var productElement = $(`[data-prodsuggest='${item.product_id}']`);

          if (productElement.length) {
            // If element exists (match), hide it
            productElement.hide();
          }
        });

        // Loop through all possible product suggestion elements and show those not in the cart
        $("[data-prodsuggest]").each(function() {
          var productId = $(this).data("prodsuggest");
          var isInCart = cart.items.some(item => item.product_id === productId);

          if (!isInCart) {
            // If the item is not in the cart, show it
            $(this).show();
          }
        });

        let cartCount = cart.item_count;
        $('.js-cart-count').text(cartCount);
        if (cartCount == 1) {
          $(".js-cart-sidebar__title").text(`Your cart (${cartCount} Item)`);
        } else {
          $(".js-cart-sidebar__title").text(`Your cart (${cartCount} Items)`);
        }
        if (cartCount > 0) {
          //$(".sidecart-recommended-product").show();
          $(".cart-sidebar__empty-cart").hide();
          $(".cart-sidebar__default-cart").show();
          $(".js-product-review").hide();
          $(".cart-product-review").hide();
          $(".js-cart-sidebar__summry-wrap").show();
          $(".js-cart-sidebar__summry-note").show();
          $(".cart-sidebar__atc-wrapper").show();
        } else {
          //$(".sidecart-recommended-product").hide();
          $(".cart-sidebar__empty-cart").show();
          $(".cart-product-review").show();
          $(".cart-sidebar__default-cart").hide();
          $(".js-product-review").show();
          $(".js-cart-sidebar__summry-wrap").hide();
          $(".js-cart-sidebar__summry-note").hide();
          $(".cart-sidebar__atc-wrapper").hide();
        }

        let sideCartRecommendedProduct = document.querySelectorAll(".js-sidecart-recommended-product");
       if (sideCartRecommendedProduct.length > 0) {
        sideCartRecommendedProduct.forEach(currentSideCartRecommendedProduct => {
          if (!currentSideCartRecommendedProduct.swiper) {
            new Swiper(currentSideCartRecommendedProduct, {
              slidesPerView: parseFloat(currentSideCartRecommendedProduct.getAttribute("data-slide-mobile")).toFixed(2)
                || 1,
              spaceBetween: 12,
              autoplay: false,
              speed: 800,
              loop: false,
              freeMode: false,
              pagination: false,
              grabCursor: true,
              breakpoints: {
                992: {
                  slidesPerView:
                    parseFloat(currentSideCartRecommendedProduct.getAttribute("data-slide-desktop"), 10).toFixed(2)
                    || 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView:
                    parseFloat(currentSideCartRecommendedProduct.getAttribute("data-slide-tablet"), 10).toFixed(2) || 1,
                  spaceBetween: 20,
                },
              },
              navigation: {
                nextEl: currentSideCartRecommendedProduct.nextElementSibling.querySelector(".swiper-button-next"),
                prevEl: currentSideCartRecommendedProduct.nextElementSibling.querySelector(".swiper-button-prev"),
              },
              on: {
                init: function() {
                  updateSliderState(this, currentSideCartRecommendedProduct);
                  bestSellerProductsElementMatchHeight(currentSideCartRecommendedProduct);
                },
                resize: function() {
                  updateSliderState(this, currentSideCartRecommendedProduct);
                  bestSellerProductsElementMatchHeight(currentSideCartRecommendedProduct);
                },
              },
            });

            // currentSideCartRecommendedProduct.swiper = swiperInstance;
          } else {
            let CartRecommendedProductSwiperInstance = currentSideCartRecommendedProduct.swiper;
            CartRecommendedProductSwiperInstance.update();
          }
        });
      }
      let sideCartBestSellerProduct = document.querySelectorAll(".js-sidecart-best-product");
      

      if (sideCartBestSellerProduct.length > 0) {
        sideCartBestSellerProduct.forEach(currentSideCartBestSellerProduct => {
          if (!currentSideCartBestSellerProduct.swiper) {
            new Swiper(currentSideCartBestSellerProduct, {
              slidesPerView: parseFloat(currentSideCartBestSellerProduct.getAttribute("data-slide-mobile")).toFixed(2)
                || 1.1,
              spaceBetween: 12,
              autoplay: false,
              speed: 800,
              loop: false,
              freeMode: false,
              pagination: false,
              grabCursor: true,
              breakpoints: {
                992: {
                  slidesPerView:
                    parseFloat(currentSideCartBestSellerProduct.getAttribute("data-slide-desktop"), 10).toFixed(2)
                    || 1.53,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView:
                    parseFloat(currentSideCartBestSellerProduct.getAttribute("data-slide-tablet"), 10).toFixed(2)
                    || 1.1,
                  spaceBetween: 20,
                },
              },
              navigation: {
                nextEl: currentSideCartBestSellerProduct.nextElementSibling.querySelector(".swiper-button-next"),
                prevEl: currentSideCartBestSellerProduct.nextElementSibling.querySelector(".swiper-button-prev"),
              },
              on: {
                init: function() {
                  updateSliderState(this, currentSideCartBestSellerProduct);
                  bestSellerProductsElementMatchHeight(currentSideCartBestSellerProduct);
                },
                resize: function() {
                  updateSliderState(this, currentSideCartBestSellerProduct);
                  bestSellerProductsElementMatchHeight(currentSideCartBestSellerProduct);
                },
              },
            });

            // currentSideCartBestSellerProduct.swiper = swiperInstance;
          } else {
            let SideCartBestSellerSwiperInstance = currentSideCartBestSellerProduct.swiper;
            SideCartBestSellerSwiperInstance.update();
          }
        });
      }
      let productReviewSlider = document.querySelectorAll(".enable-product-review-slider .js-product-review-slider");
      if (productReviewSlider && productReviewSlider.length > 0) {
        productReviewSlider.forEach(function(currentProductReviewSlider) {
          if (!currentProductReviewSlider.swiper) {
            new Swiper(currentProductReviewSlider, {
              loop: false,
              spaceBetween: 10,
              slidesPerView: parseFloat(currentProductReviewSlider.getAttribute("data-slide-mobile"), 10).toFixed(2)
                || 1,
              autoplay: false,
              speed: 500,
              pagination: false,
              grabCursor: true,
              breakpoints: {
                1200: {
                  spaceBetween: 20,
                  slidesPerView:
                    parseFloat(currentProductReviewSlider.getAttribute("data-slide-desktop"), 10).toFixed(2) || 1.1,
                },
                992: {
                  slidesPerView:
                    parseFloat(currentProductReviewSlider.getAttribute("data-slide-desktop"), 10).toFixed(2) || 1.1,
                  spaceBetween: 12,
                },
                768: {
                  slidesPerView: parseFloat(currentProductReviewSlider.getAttribute("data-slide-tablet"), 10).toFixed(2)
                    || 1,
                  spaceBetween: 20,
                },
              },
            });
          } else {
            currentProductReviewSlider.swiper.update();
          }
        });
      }
      let recProLength = $(".js-sidecart-recommended-product__slide:visible").length;
      if (recProLength > 0) {
        $(".cart-sidebar__recommended-product").show();
      } else {
        $(".cart-sidebar__recommended-product").hide();
      }
       setTimeout(function() {
        if (cart.item_count > 0) {
          $(".sidecart-recommended-product").show();
        } else {
           $(".sidecart-recommended-product").hide();
        }
      }, 500);
      });
      
      setTimeout(function() {
        $(".js-loader-wrap").removeClass("active");
      }, 500);  
    },
  });
}




$(document).on("click", ".js-plus-drawer", function(e) {
  e.preventDefault();
  let parent = $(e.target).parents(".js_product-quantity__box");
  let current_qty = $(parent).find(".js_drawer_quantity").val();
  let updated_qty = parseInt(current_qty) + 1;
  let current_item = {};
  let key = $(parent).attr("data-key");
  current_item[key] = updated_qty;
  $.ajax({
    url: "/cart/update.js",
    data: {
      "updates": current_item,
    },
    method: "POST",
    dataType: "JSON",
    success: function(data) {
      updateCart();
    },
    error: function(error) {
      console.log(error);
    },
  });
});


$(document).on("click", ".js-minues-drawer", function(e) {
  e.preventDefault();
  let parent = $(e.target).parents(".js_product-quantity__box");
  let current_qty = $(parent).find(".js_drawer_quantity").val();
  let updated_qty = parseInt(current_qty) - 1;
  let current_item = {};
  let key = $(parent).attr("data-key");
  let uniqueId = $(this).parent(`[data-uid]`).attr('data-uid');
  console.log("uniqueId", uniqueId);
  if(uniqueId.toString().trim() !== "") {
          //remove multiple items
    $(`[data-uid='${uniqueId}']`).each(function(ix,em){
      let key2 = $(em).attr('data-key');
      console.log("key2", key2);
      current_item[key2] = updated_qty;
    });
  } else {
      current_item[key] = updated_qty;
  }
 
  $.ajax({
    url: "/cart/update.js",
    data: {
      "updates": current_item,
    },
    method: "POST",
    dataType: "JSON",
    success: function(data) {
      updateCart();
    },
    error: function(error) {
      console.log(error);
    },
  });
});

function goToSlide(n) {
  document.querySelector(".js-main-product-nav-slider").swiper.slideTo(n - 1, 0);
}

function updateInstallments(variant_id) {
  var $installmentForm = $('.js-installment-form');
  if (!$installmentForm.length) return;

  var $wrapper = $installmentForm.find('.js-installment-wrapper');
  var $oldTerms = $wrapper.find('shopify-payment-terms');

  if (!$oldTerms.length) return;

  // Prevent unnecessary re-render
  if ($oldTerms.attr('variant-id') === String(variant_id)) return;

  // Update hidden input
  $installmentForm.find('.js_installment').val(variant_id);

  // Create a temporary placeholder to avoid layout jump
  var height = $oldTerms.outerHeight();
  $oldTerms.css({ visibility: 'hidden' }); // hide but keep space

  // Replace the old <shopify-payment-terms> with new one
  var newTerms = $('<shopify-payment-terms>', {
    'variant-id': variant_id,
    'shopify-meta': $oldTerms.attr('shopify-meta'),
    'ux-mode': $oldTerms.attr('ux-mode'),
    'show-new-buyer-incentive': $oldTerms.attr('show-new-buyer-incentive'),
  }).css({ display: 'none' });

  $wrapper.append(newTerms); // append new terms

  // Fade in the new terms
  newTerms.fadeIn(300, function() {
    // Remove old terms after new one is fully visible
    $oldTerms.remove();
    $wrapper.css('min-height', ''); // reset min-height
  });

  // Maintain layout height while new iframe loads
  $wrapper.css('min-height', height + 'px');
}


$(document).ready(function() {
  $(document).on(
    "change",
    `.js-cw-product-page-form [data-option-1], .js-cw-product-page-form [data-option-2],.js-cw-product-page-form [data-option-3]`,
    function(e) {
      let option1 = option2 = option3 = null;
      if ($(`.js-cw-product-page-form [data-option-1]`).length > 0) {
        option1 = $(`.js-cw-product-page-form [data-option-1] input:checked`).val();
      }
      if ($(`.js-cw-product-page-form [data-option-2]`).length > 0) {
        option2 = $(`.js-cw-product-page-form [data-option-2] input:checked`).val();
      }
      if ($(`.js-cw-product-page-form [data-option-3]`).length > 0) {
        option3 = $(`.js-cw-product-page-form [data-option-3] input:checked`).val();
      }
      let variant_id = null;
      let current_selected_option = null;
      if (option2 == null & option3 == null) {
        current_selected_option = $(
          `.js-cw-product-page-form select.actual-variants option[data-option1='${option1}']`,
        );
        variant_id = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}']`).val();
      }
      if (option2 != null & option3 == null) {
        current_selected_option = $(
          `.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}']`,
        );
        variant_id = $(
          `.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}']`,
        ).val();
      }
      if (option2 != null & option3 != null) {
        current_selected_option = $(
          `.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`,
        );
        variant_id = $(
          `.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`,
        ).val();
      }
      if (variant_id == null) {
        //$(`.js-cw-product-page-form .js_product_page-atc`).addClass("soldout");
        $(`.js_product_page-atc span`).text("Unavailable");
        $(`.js_product_page-atc`).css("pointer-events", "none");
        $(`.js_product_page-atc`).css("opacity", "0.5");
        $(`.js-eq-button__icon`).hide();
        return true;
      }
      let price = $(current_selected_option).attr("data-price");
      let compare_at_price = $(current_selected_option).attr("data-compareat-price");
      let itemQty = $(current_selected_option).attr("data-qty");
      let is_available = $(current_selected_option).attr("data-available");
      let savPercentage = $(current_selected_option).attr("data-save-per");
      let variantTitle = $(current_selected_option).attr("data-variant-title");
      let option1Value = $(current_selected_option).attr("data-opt1-val");
      let option2Value = $(current_selected_option).attr("data-opt2-val");
      let option3Value = $(current_selected_option).attr("data-opt3-val");
      let withOutCurrencyCompare = $(current_selected_option).attr("data-without-currency-compare_price");
      let addToCartText = $(`.js_product_page-atc`).attr('data-atc-text');
      let soldOutText = $(`.js_product_page-atc`).attr('data-sold-text')
      $(`.js-cw-product-page-form select.actual-variants`).val(variant_id).trigger("change");
     
      let proVarId = $(`.js-cw-product-page-form select.actual-variants option:selected`).attr('data-value');
      updateInstallments(proVarId);
      if (option1Value) {
        $(".js-option-value-1").text(option1Value);
      }

      if (option2Value) {
        $(".js-option-value-2").text(option2Value);
      }

      if (option3Value) {
        $(".js-option-value-3").text(option3Value);
      }

      $(".js-price").text(price);
      

      $(".js-compare-price").text(compare_at_price);
      if (withOutCurrencyCompare > 0) {
        $(".js-save-percentage").text(`Save ${savPercentage}`);
        $(".js-save-percentage").css("display", "flex");
      } else {
        $(".js-save-percentage").hide();
      }
      $(`.jsproqty`).text(itemQty);
      if (is_available == "true") {
        $(`.js_product_page-atc .eq-button__text`).text(`${addToCartText}`);
        $(`.js_product_page-atc`).css("pointer-events", "all");
        $(`.js_product_page-atc`).css("opacity", "1");
        $(`.js-eq-button__icon`).show();
      } else {
        $(`.js_product_page-atc`).css("pointer-events", "none");
        $(`.js_product_page-atc`).css("opacity", "0.5");
        $(`.js_product_page-atc .eq-button__text`).text(`${soldOutText}`);
        $(`.js-eq-button__icon`).hide();
      }
      
      var imagePath = $(".actual-variants option:selected").attr("data-image");
      $(".main_slider_image").each(function() {
        var image_index = $(this).attr("data-slide-index");
        var slick_image = $(this).find("img").attr("data-pro-img");
        if (slick_image == imagePath) {
          goToSlide(image_index);
        }
      });
    },
  );

  $(document).on("click", ".eq-bundle-product-atc", function(e) {
    e.preventDefault();
    let varId = $(this).attr("data-bundle-id");
    let qty = 1;
    $.ajax({
      url: "/cart/add.js",
      method: "POST",
      data: {
        id: varId,
        quantity: qty,
      },
      dataType: "json",
      success: function(data) {
        updateCart();
        $(".cart-sidebar").addClass("is-cart-drawer-open");
        $("body").addClass("is-cart-drawer-open is-hidden");
      },
      error: function(xhr, status, error) {
        console.error("Error adding to cart:", error);
        console.error("Response Text:", xhr.responseText);
        window.alert(xhr.responseJSON.description);
      },
    });
  });

  function getDynamicProperties() {
  let properties = {};

  $("[name^='properties']").each(function () {
    let name = $(this).attr("name");
    let value = $(this).val();

    if (value && value !== "") {
      let key = name.replace("properties[", "").replace("]", "");
      properties[key] = value;
    }
  });

  return properties;
}


$(document).on('click', '.js_product_page-atc', function(e) {
    e.preventDefault();
    var $form = $('form.cw-product-page-form');
    var variant_id = $('.js_product_var_change option:selected').attr('data-value');
    var insertProductId = $('.insert_product_radio_button:checked').attr('data-product-id');
    var flowProductId = $('.js-product-variant__wrap:visible').find('.flow-product-variant-radio-button:checked').attr('data-variant-id');
    var insertProductQty = $('.insert_product_radio_button:checked').attr('data-qty');
    let qtyBoxVisible = $(".main-product__quantity-atc").attr("data-hide-qty");
    let insertDiscountCode = $('.insert_product_radio_button:checked').attr('data-discount-code');
    let UID = +new Date() + Math.floor(Math.random() * 1000);
    let qty;
    let addToCartText = $(`.js_product_page-atc`).attr('data-atc-text');
    $(`.js_product_page-atc .eq-button__text`).text(`Adding...`);
    //$(`.eq-buy--now`).text(`Adding...`);
    $(`.eq-button__icon`).hide();

    if (qtyBoxVisible == "true") {
        qty = 1;
    } else {
        qty = $(".js-main-product__quantity-input").val();
    }

    if (!variant_id) {
        console.error('Variant ID missing');
        return;
    }
    // Ensure required fields exist in form
    if ($form.find('input[name="id"]').length === 0) {
        $form.append('<input type="hidden" name="id" value="' + variant_id + '">');
    } else {
        $form.find('input[name="id"]').val(variant_id);
    }
    if ($form.find('input[name="quantity"]').length === 0) {
        $form.append('<input type="hidden" name="quantity">');
    }
    $form.find('input[name="quantity"]').val(qty);
    var formDataSerialized = $form.serialize();
    formDataSerialized += '&properties[_uid]=' + encodeURIComponent(UID);
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: formDataSerialized,
        success: function(res) {
            if (insertProductId) {
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    dataType: 'json',
                    data: {
                        id: insertProductId, // MUST be variant ID
                        quantity: insertProductQty,
                        properties: {
                          _uid: UID,
                          _custom_product: "custom_product",
                        }
                    },
                    success: function() {
                        updateCart();
                        $(".cart-sidebar").addClass("is-cart-drawer-open");
                        $("body").addClass("is-cart-drawer-open is-hidden");
                        $('.js_product_page-atc .eq-button__text').text('Added!');
                        $(`.js_product_page-atc .eq-button__text`).text(`${addToCartText}`);
                        $(`.eq-button__icon`).show();
                        //$(`.eq-buy--now`).text(`Buy Now`);
                    },
                    error: function(xhr) {
                        console.error('Extra product error:', xhr.responseText);
                    }
                });
            } else if (flowProductId) {
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    dataType: 'json',
                    data: {
                        id: flowProductId, // MUST be variant ID
                        quantity: 1,
                        properties: {
                          _uid: UID,
                          _custom_product: "custom_product",
                        }
                    },
                    success: function() {
                        updateCart();
                        $(".cart-sidebar").addClass("is-cart-drawer-open");
                        $("body").addClass("is-cart-drawer-open is-hidden");
                        $('.js_product_page-atc .eq-button__text').text('Added!');
                        $(`.js_product_page-atc .eq-button__text`).text(`${addToCartText}`);
                        $(`.eq-button__icon`).show();
                        //$(`.eq-buy--now`).text(`Buy Now`);
                    },
                    error: function(xhr) {
                        console.error('Flow product error:', xhr.responseText);
                    }
                });
            } else {
                updateCart();
                $(".cart-sidebar").addClass("is-cart-drawer-open");
                $("body").addClass("is-cart-drawer-open is-hidden");
                $('.js_product_page-atc .eq-button__text').text('Added!');
                $(`.js_product_page-atc .eq-button__text`).text(`${addToCartText}`);
                $(`.eq-button__icon`).show();
                //$(`.eq-buy--now`).text(`Buy Now`);
            }
        },
        error: function(xhr) {
            console.error(xhr.responseText);
        }
    });
});








  $(".js-scroll-btn").on("click", function(e) {
    e.preventDefault();
    $("html, body").animate({
      scrollTop: $("#main_product").offset().top, // Change #target-id to your element's ID
    }, 800 // duration in ms (800 = 0.8s)
    );
  });

  $(".js-review-section").on("click", function(e) {
    e.preventDefault();

    $("html, body").stop().animate({
        scrollTop: $("#js-review-sec").offset().top
    }, 800);

    setTimeout(function() {
        $("html, body").stop().animate({
            scrollTop: $("#js-review-sec").offset().top
        }, 200);
    }, 200);
});

  

  $(document).on("click", ".js-product-remove", function() {

	let lineItemKey = $(this).attr("data-key");

	// get UID from same cart item block
	let currentUID = $(this)
		.closest("[data-_uid]")
		.attr("data-_uid");
  let updates = {};
  if (currentUID && currentUID.toString().trim() !== "") {
		$(`[data-_uid='${currentUID}']`).each(function(ix, em) {
			let key2 = $(em).attr("data-key");

			if (key2) {
				updates[key2] = 0;
			}
		});
	} else {
		updates[lineItemKey] = 0;
	}

	fetch("/cart/update.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				updates: updates
			}),
		})
		.then(response => response.json())
		.then(cart => {
			updateCart();
		})
		.catch(error => {
			console.error("Error removing item from cart:", error);
		});

});
  $(".product-variant__input:checked").trigger("change");
});

$(document).on("click", ".upsell-drawer-atc", function(e) {
  e.preventDefault();
  let varId = $(this).attr("data-id");

  let qty = 1;
  $.ajax({
    url: "/cart/add.js",
    method: "POST",
    data: {
      id: varId,
      quantity: qty,
    },
    dataType: "json",
    success: function(data) {
      updateCart();
    },
    error: function(xhr, status, error) {
      console.error("Error adding to cart:", error);
      console.error("Response Text:", xhr.responseText);
      window.alert(xhr.responseJSON.description);
    },
  });
});

$(document).on("click", ".js-best-selling-product--atc", function(e) {
  e.preventDefault();
  let varId = $(this).attr("data-id");
  let qty = 1;
  $.ajax({
    url: "/cart/add.js",
    method: "POST",
    data: {
      id: varId,
      quantity: qty,
    },
    dataType: "json",
    success: function(data) {
      updateCart();
      $(".cart-sidebar").addClass("is-cart-drawer-open");
      $("body").addClass("is-cart-drawer-open is-hidden");
    },
    error: function(xhr, status, error) {
      console.error("Error adding to cart:", error);
      console.error("Response Text:", xhr.responseText);
      window.alert(xhr.responseJSON.description);
    },
  });
});



$(document).on("click", ".js-cart-sidebar-close", function(e) {
  e.preventDefault();
  $("#eq-cart").removeClass("is-cart-drawer-open");
  $("body").removeClass("is-cart-drawer-open is-hidden");
});

var shoppingCart1 = document.querySelector(".js-cart-icon");
var sideCartClose1 = document.querySelector(".js-cart-sidebar-close");
var sidebarCartBlock1 = document.querySelector(".cart-sidebar");

if (sidebarCartBlock && shoppingCart1) {
  shoppingCart1.addEventListener("click", function(event) {
    event.preventDefault();
    //updateCart();
    // Close menu if open
    if (
      document.querySelector(".eq-sidebar-menu")?.classList.contains("is-active-menu")
      && document.body.classList.contains("is-active-menu")
    ) {
      closeIcon?.click();
    }

    // Close search if open
   

    // Open cart drawer
    if (
      sidebarCartBlock1 && !sidebarCartBlock1.classList.contains("is-cart-drawer-open")
      && !document.body.classList.contains("is-cart-drawer-open")
    ) {
      sidebarCartBlock1.classList.add("is-cart-drawer-open");
      document.body.classList.add("is-cart-drawer-open", "is-hidden");
    }
  });
}


$(document).on("click", ".js-cart-icon", function(e) {
   $.getJSON("/cart.json", function(cart) {
       let cartCount = cart.item_count;
        loadSidecartRecommendations(cart); 
        $('.js-cart-count').text(cartCount);
        if (cartCount == 1) {
          $(".js-cart-sidebar__title").text(`Your cart (${cartCount} Item)`);
        } else {
          $(".js-cart-sidebar__title").text(`Your cart (${cartCount} Items)`);
        }
        if (cartCount > 0) {
          $(".sidecart-recommended-product").show();
          $(".cart-sidebar__empty-cart").hide();
          $(".cart-sidebar__default-cart").show();
          $(".js-product-review").hide();
           $(".cart-product-review").hide();
          $(".js-cart-sidebar__summry-wrap").show();
           $(".cart-sidebar__atc-wrapper").show();
        } else {
          $(".sidecart-recommended-product").hide();
          $(".cart-sidebar__empty-cart").show();
          $(".cart-sidebar__default-cart").hide();
          $(".cart-product-review").show();
          $(".js-product-review").show();
          $(".js-cart-sidebar__summry-wrap").hide();
           $(".cart-sidebar__atc-wrapper").hide();
        }

     
      });
});



// // Trigger when any insert_product_radio_button changes
// $(document).on('change', '.insert_product_radio_button', function() {
//     // Get the selected radio button
//     var $selected = $('.insert_product_radio_button:checked');
//     var totalPrice =  $('.js-bundle-price').attr('data-total-price'); //
//     var price = $selected.data('price');
//     console.log(price)
//     totalPrice = parseFloat(totalPrice) + parseFloat(price);
//     $('.js-bundle-price').text('$' + totalPrice.toFixed(2));
//     $('.js-bundle-price').attr('data-total-price', totalPrice.toFixed(2));
//     console.log("price", price);
//     // Extract the data attributes
//     var insertText = $selected.val();
//     $('.js-option-value-bundle-indesrt-product').text(insertText)
    
// });
function calculateTotalPrice() {
   let total = 0;
   let compareTotal = 0;
   let savingPriceTotal = 0;
   var bundleComparePrice = $('.js-bundle-compare--price').data('compare-at-price');
    $('.product-variant__input:checked').each(function() {
        const price = parseFloat($(this).attr('data-price')) || 0;
        const comparePrice = parseFloat($(this).attr('data-original-price')) || 0;
        const savingPrice = parseFloat($(this).attr('data-discounted-price')) || 0;
        total += savingPrice;
        compareTotal += comparePrice;
        savingPriceTotal += savingPrice;
        if (compareTotal > 0) {
              var savingsPercent = ((compareTotal - savingPriceTotal) / compareTotal) * 100;
              if(savingsPercent > 0){
                  $('.js-save-bundle-percentage ').show();
                  $('.js-compare-price').show();
                }else{
                  $('.js-save-bundle-percentage ').hide();
                  $('.js-compare-price').hide();
                }
              $('.js-save-bundle-percentage').text('Save ' + Math.round(savingsPercent) + '%');
            } else {
              $('.js-save-bundle-percentage').text('');
            }
    });

    // Optional: update UI element
    //$('#total_price_display').text(total.toFixed(2));
    $('.js-bundle-price').text('$' + total.toFixed(2));
    $('.js-compare-price').text('$' + compareTotal.toFixed(2));
    $('.js-bundle-price').attr('data-total-price', total.toFixed(2));
}

function calculateTotalPriceFlowProduct() {
   let total = 0;
   let compareTotal = 0;
   let savingPriceTotal = 0;
   var bundleComparePrice = $('.js-bundle-compare--price').data('compare-at-price');

    $('.product-variant__input:checked').each(function() {
        let parent = $(this).closest('.product-variant__wrap:visible');
        //const price = parseFloat($(this).attr('data-price')) || 0;
       let varPrice = parseFloat(parent.find('.product-variant__input:checked').attr('data-price')) || 0;
        var flowComparePrice = parseFloat(parent.find('.product-variant__input:checked').attr('data-original-price')) || 0;
        const savingPrice = parseFloat(parent.find('.product-variant__input:checked').attr('data-discounted-price')) || 0;
        total += savingPrice;
         compareTotal += flowComparePrice;
        if (compareTotal > 0) {
              var savingsPercent = ((compareTotal - total) / compareTotal) * 100;
               if(savingsPercent > 0){
                  $('.js-save-bundle-percentage ').show();
                  $('.js-compare-price').show();
                }else{
                  $('.js-save-bundle-percentage ').hide();
                  $('.js-compare-price').hide();
                }
              $('.js-save-bundle-percentage').text('Save ' + Math.round(savingsPercent) + '%');
            } else {
              $('.js-save-bundle-percentage').text('');
            }
    });

    // Optional: update UI element
    //$('#total_price_display').text(total.toFixed(2));
    $('.js-bundle-price').text('$' + total.toFixed(2));
    $('.js-compare-price').text('$' + compareTotal.toFixed(2));
    $('.js-bundle-price').attr('data-total-price', total.toFixed(2));
}
$(document).on('change', '.insert_product_radio_button', function() {
  calculateTotalPrice();
  let insertProductVal = $('.insert_product_radio_button:checked').val();
  $('.js-option-value-bundle-indesrt-product').text(insertProductVal);
});

$(document).on('change', '.flow-product-variant-radio-button', function() {
  let selectedFlowValue = $(this).val();
  $('.js-option-value-bundle-indesrt-product').text(selectedFlowValue);
  calculateTotalPriceFlowProduct();
});


$(document).on('change', '.js-flow-product-variants', function() {
  let selectedFlow = $('.js-flow-product-variants:checked').val();
  calculateTotalPriceFlowProduct();
  if(selectedFlow == 'Flow'){
    $('.flow-pro-product-variant').hide();
    $('.flow-product-variant').show();  
 
  } else {
    $('.flow-pro-product-variant').show();
    $('.flow-product-variant').hide();
    
  }
   
});


function updateBundleOptionValue(element) {

    const selectedValue = $(element).attr('data-label-val');

    console.log("selectedValue " + selectedValue);

    // get current option wrapper
    const currentWrapper = $(element).closest('.product-variant__wrap');

    // print value in related element
    currentWrapper.find('.js-option-value-bundle').text(selectedValue);
}

// on change
$(document).on('change', '.js_bundle_product_items', function () {
    updateBundleOptionValue(this);
});

// on load checked input
$('.js_bundle_product_items:checked').each(function () {
    updateBundleOptionValue(this);
});

$(document).on('click', '.js-flow-product-variants-redirection', function () {
  const value = $(this).attr('data-opt-val').toLowerCase().trim();

  if (value === 'flow') {
    window.location = '/products/healix-circulation-domination-bundle';
  } else if (value === 'flow pro') {
    window.location = '/products/healix-circulation-domination-bundle-flow-pro-product';
  }
});

(function () {
  var TRIGGER = '.js-review-scroll-btn';
  var TARGET  = '#js-review';

  // 1) Lazy images ne pehla thi load kari do, jethi layout shift na thay
  function eagerLoad() {
    document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      img.setAttribute('loading', 'eager');
    });
    document.querySelectorAll('img[data-src], img[data-lazy-src]').forEach(function (img) {
      var s = img.getAttribute('data-src') || img.getAttribute('data-lazy-src');
      if (s && !img.getAttribute('src')) img.setAttribute('src', s);
    });
  }
  window.addEventListener('load', eagerLoad);
  setTimeout(eagerLoad, 1500);

  function headerOffset() {
    var h = document.querySelector('header, .header, .site-header, .header-wrapper');
    if (!h) return 10;
    var pos = getComputedStyle(h).position;
    return (pos === 'fixed' || pos === 'sticky') ? h.offsetHeight + 10 : 10;
  }

  function targetY() {
    var el = document.querySelector(TARGET);
    if (!el) return null;
    return Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - headerOffset());
  }

  function ease(t) { return t < 0.5 ? 2*t*t : 1 - Math.pow(-2*t + 2, 2) / 2; }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest(TRIGGER);
    if (!trigger) return;
    e.preventDefault();

    eagerLoad();

    var startY   = window.pageYOffset;
    var startT   = performance.now();
    var DURATION = 700;    // smooth animation time
    var SETTLE   = 1500;   // aa pachhi pan thodo time position correct karta raho
    var cancelled = false;

    function cancel() { cancelled = true; }
    window.addEventListener('wheel', cancel, { once: true, passive: true });
    window.addEventListener('touchstart', cancel, { once: true, passive: true });

    (function frame(now) {
      if (cancelled) return;
      var y = targetY();
      if (y === null) return;

      var elapsed = now - startT;
      if (elapsed < DURATION) {
        var p = ease(elapsed / DURATION);
        window.scrollTo(0, startY + (y - startY) * p);   // target darek frame ma fari gane che
      } else {
        window.scrollTo(0, y);                           // final position lock
      }

      if (elapsed < DURATION + SETTLE) requestAnimationFrame(frame);
    })(startT);
  });

  var t = document.querySelector(TRIGGER);
  if (t) t.style.cursor = 'pointer';
})();